type AboutUsMissionDataType = {
  caption: string
  items: Record<string, string>[]
}

export const aboutUsMissionData: AboutUsMissionDataType[] = [
  {
    caption: 'Introduction',
    items: [
      {
        text: 'We strongly believe that in 10 years, software companies will operate on thousands of specialized apps, all seamlessly interconnected.',
      },
      {
        text: 'It is increasingly essential for products to communicate effortlessly. Consider the B2C apps on your phone — they can exchange data easily with just a few taps in seconds.',
      },
      {
        text: "However, for B2B apps, the situation is far more complicated. Integrating a new SaaS into a company's software stack often turns into a project spanning weeks or months.",
      },
    ],
  },
  {
    caption: 'Description',
    items: [
      {
        text: 'To integrate your app with another, typically a developer must read and understand new API documentation, write code, and begin the integration process into their own app. Often, this is a repetitive and arduous process, which we believe should not be the case.',
      },
      {
        text: 'Our goal is to become the central hub between SaaS apps, creating a network that is easily accessible and fosters innovation across platforms.',
      },
      {
        text: 'Recent advances in AI with large language models are pivotal in making this vision a reality, and Integration App aims to be at the forefront of this transformation.',
      },
    ],
  },
]
